import type { FaireProductEntity } from "../../entity_types/product";

export const p_gtjj3fxtpv: FaireProductEntity = {
  token: "p_gtjj3fxtpv",
  type: "product",
  name: "Volcano 16 oz 100% Soy Candle",
  brandToken: "b_rnzbyn79fg",
  brandName: "Ember Water",
  imageUrl:
    "https://cdn.faire.com/fastly/74468c846acfc1e858f44c11bfd4f14945a0ea62cb17f16b98860d6baeac089a.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a97b5e112d57876570d2354fa9149d881bf4f1a79200608cd9699b1a80c4dc27.png",
    "https://cdn.faire.com/fastly/29c34b6081e1f3c638940c2eea2816d13488a41350f358c0eb0f1d551951f17a.png",
  ],
  priceDollars: 12,
  description:
    "Inspired by luxury scents, without the luxury price.\n\nThe alluring smell of tropical fruits, sugared oranges, lemons and limes rounded out by exotic mountain greens.\n\nOur candles are made with 100% American soy wax phthalate-free fragrance oils and a lead-free cotton wicks. Each 16 oz candle burns for 70 hours.\n\n𝐂𝐚𝐧𝐝𝐥𝐞 𝐂𝐚𝐫𝐞:\n• Trim the carbon build up off your wicks before each new burn as needed. If at any point you notice high flames or soot/smoke emitting from your candle, blow it out, trim the wicks and re-light.\n• Allow the candle to burn for a full 4 hours during the first burn. This will help to avoid tunneling in the candle.\n• Don't leave your candle burning for longer than 4 hours at a time. Do not allow candle to burn when there is less than a 1/4\" of wax remaining.\n• Keep away from children, pets, drafts, flammable objects and surfaces.\n\nAll products are made to order and we do our best to ship your order as quickly as possible.",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:10.933Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
